import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { PRODUCT_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { SpecimenInstitutionPage } from '@/features/product/pages/SpecimenInstitutionPage';
import { specimenInstitutionSearchSchema } from '@/features/product/types/product.types';

export const Route = createFileRoute('/_auth/product/specimen-institution')({
  beforeLoad: () => requirePermission(PRODUCT_PERMISSIONS.SPECIMEN_INSTITUTION_VIEW),
  validateSearch: specimenInstitutionSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="View Specimen Institution">
      <Suspense fallback={<PageLoader />}>
        <SpecimenInstitutionPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
